import {I18n} from 'aws-amplify/utils';

import {SimplePageHeader,} from '@flexinet/ui-components';
import {useVerifiedPermissions} from "../../../hooks/useVerifiedPermissions.ts";
import {AddRecordButton} from '../buttons/AddRecordButton.tsx';
import {ReloadRecordsButton} from '../buttons/ReloadRecordsButton.tsx';
import {FilterRecordsButton, AliasFilters} from '../buttons/FilterRecordsButton.tsx';
import {DeleteRecordButton} from '../buttons/DeleteRecordButton.tsx';
import {GenerateAliasButton} from '../../test-data/buttons/GenerateAliasButton.tsx';
import {isTestDataEnabled} from '../../test-data/isTestDataEnabled.ts';
import {config} from "../config";
import {AliasStatus} from '../types';
import {rbacActions} from "../../../config/rbac/actions.ts";

interface IndexPageHeaderProps {
    onFilterChange: (filters: AliasFilters) => void;
}

const useTools = (onFilterChange: (filters: AliasFilters) => void) => {

    const {allowedActions} = useVerifiedPermissions()

    const tools = [
        <FilterRecordsButton key='filter' onFilterChange={onFilterChange} defaultFilters={{aliasStatus: AliasStatus.ENABLED, aliasType: null}}/>,
        <ReloadRecordsButton key='reload'/>
    ];

    // FNP-1577: generation WRITES aliases, so it sits behind the same permission
    // as creating one — otherwise it is a way around that permission. The stage
    // check is here as well as inside the button because the MOUNT decision is
    // what a test can observe, and a button that is never mounted is the FNP-1027
    // failure: green tests, unreachable control.
    if (isTestDataEnabled() && allowedActions.includes(rbacActions.CreateAlias)) {
        tools.push(<GenerateAliasButton key='generate'/>);
    }

    if (allowedActions.includes(rbacActions.DeleteAlias)) {
        tools.push(<DeleteRecordButton key='delete'/>);
    }

    if (allowedActions.includes(rbacActions.CreateAlias)) {
        tools.push(<AddRecordButton key='add'/>);
    }


    return tools;
};

export const IndexPageHeader = ({onFilterChange}: IndexPageHeaderProps) => {
    return (
        <SimplePageHeader
            title={I18n.get(config.titles.plural)}
            tools={useTools(onFilterChange)}
        />
    );
};
